import { $getNodeByKey, NodeKey } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Body2 } from '@/components/@IntranetLibrary/Typography';
import { CircleDeleteIcon } from '@/theme/overrides/CustomIcons';
import Spinner from '@/components/@IntranetLibrary/Spinner';
import { UploadImageStatus } from '@/components/LexicalEditor/nodes/UploadImageNode';
import { Backdrop, DeleteButton, PreviewImage, Wrapper } from './styled';

function UploadImage({
  src,
  altText,
  status,
  nodeKey,
}: {
  src: string;
  altText: string;
  status: UploadImageStatus;
  nodeKey: NodeKey;
}) {
  const [editor] = useLexicalComposerContext();
  const { t } = useTranslation();

  if (status === 'loading') {
    return (
      <Wrapper>
        <Backdrop>
          <Spinner theme={'white'} size={'40px'} />
        </Backdrop>
        <PreviewImage src={src} alt={altText} />;
      </Wrapper>
    );
  }

  if (status === 'error') {
    return (
      <Box sx={{ position: 'relative' }}>
        <Backdrop>
          <Body2
            sx={{
              color: '#fff',
            }}
          >
            {t('업로드 실패')}
          </Body2>
        </Backdrop>
        <DeleteButton
          disableRipple
          onClick={(e) => {
            e.preventDefault();
            editor.update(() => {
              const node = $getNodeByKey(nodeKey);
              node?.remove();
            });
          }}
        >
          <CircleDeleteIcon />
        </DeleteButton>
        <PreviewImage src={src} alt={altText} />;
      </Box>
    );
  }

  return <img src={src} alt={altText} />;
}

export default UploadImage;
